<template>
	<div>
		<div class="title row">
			<div>
    			<h1>Paramètres de l'application<i class="fa fa-refresh fa-spin" aria-hidden="true"></i></h1>
			</div>
		</div>

		<v-dialog/>
		<modal 	name="modal-confirm"
				:classes="['v--modal', 'modal-confirm']"
				:pivot-y="0.2"
				:width="400"
				:height="125">
			<div class="confirm-modal-content">
				<div class="modal-title">
					<h6>Voulez-vous supprimer cette option ?</h6>
				</div>
				<div class="modal-button">
					<button @click="$modal.hide('modal-confirm')">Annuler</button>
					<button @click="destroy">Confirmer</button>
				</div>
			</div>
		</modal>

		<div class="row main-wrap">
			<div class="params">
				<div class="onglet onglet-select hidden-md hidden-lg">
					<select v-model="tab" placeholder="Choose here" required>
						<option v-if="current_user_role == 'admin'" value="catégorie">ACTION - Catégorie</option>
						<option v-if="current_user_role == 'admin'" value="action">ACTION - Type</option>
						<option value="recurring">Tâches récurrentes</option>
						<option v-if="current_user_role == 'admin'" value="domaine">HATVP - Domaines d’intervention</option>
						<option v-if="current_user_role == 'admin'" value="type_action_hatvp">HATVP - Types d’actions conduites</option>
						<option v-if="current_user_role == 'admin'" value="decideur">HATVP - Catégories de responsables publics sollicités</option>
						<option v-if="current_user_role == 'admin'" value="decision">HATVP - Décisions publiques concernées</option>
						<!-- <option value="4">Décideur [fonction]</option> -->
					</select>
				</div>
				<div class="onglets hidden-xs hidden-sm">
					<div class="onglet" @click="tab = 'catégorie'" v-if="current_user_role == 'admin'" v-bind:class="{ active: tab == 'catégorie' }">
						<h3>ACTION - Catégorie</h3>
					</div>
					<div class="onglet" @click="tab = 'action'" v-if="current_user_role == 'admin'" v-bind:class="{ active: tab == 'action' }">
						<h3>ACTION - Type</h3>
					</div>
					<div class="onglet" @click="tab = 'recurring'" v-bind:class="{ active: tab == 'recurring'}">
						<h3>Tâches récurrentes</h3>
					</div>
					<!-- <div class="onglet" @click="tab = 4" v-bind:class="{ active: tab == 4 }">
						<h3>Décideur [fonction]</h3>
					</div> -->
					<div class="onglet" @click="tab = 'domaine'" v-if="current_user_role == 'admin'" v-bind:class="{ active: tab == 'domaine' }">
						<h3>HATVP - Domaines d’intervention</h3>
					</div>
					<div class="onglet" @click="tab = 'type_action_hatvp'" v-if="current_user_role == 'admin'" v-bind:class="{ active: tab == 'type_action_hatvp' }">
						<h3>HATVP - Types d’actions conduites</h3>
					</div>
					<div class="onglet" @click="tab = 'decideur'" v-if="current_user_role == 'admin'" v-bind:class="{ active: tab == 'decideur' }">
						<h3>HATVP - Catégories de responsables publics sollicités</h3>
					</div>
					<div class="onglet" @click="tab = 'decision'" v-if="current_user_role == 'admin'" v-bind:class="{ active: tab == 'decision' }">
						<h3>HATVP - Décisions publiques concernées</h3>
					</div>
				</div>
				<div class="section-bg">
					<div v-if="tab == 'catégorie'">
						<form autocomplete="off" v-on:submit="submitForm">
							<div class="row param-form">
								<div class="form-group col-sm-7">
									<label for="categorie">Nom de la catégorie</label>
									<input type="text" id="categorie" class="form-control" v-model="name" required>
								</div>
								<div class="submit-btn col-sm-5">
									<button type="submit" class="green-btn">Ajouter</button>
								</div>
							</div>
						</form>
						<table class="table table-striped">
							<tbody>
								<tr v-for="action in all_actions_categories">
									<td>{{ action.name }}</td>
									<td class="end-cell"><button @click="show(action)" class="grey-button">-</button></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-if="tab == 'action'">
						<form autocomplete="off" v-on:submit="submitForm">
							<div class="row param-form">
								<div class="form-group col-sm-4">
									<label for="categorie">Type d'action</label>
									<input type="text" id="categorie" class="form-control" v-model="name" required>
								</div>
								<div class="form-group col-sm-4">
									<label for="type">Catégorie</label>
									<select v-model="idactioncategorie" required>
										<option value="" selected disabled>Choisissez une catégorie</option>
										<option v-bind:value="action.id" v-for="action in all_actions_categories">
											{{ action.name }}
										</option>
									</select>
								</div>
								<div class="submit-btn col-sm-4">
									<button type="submit" class="green-btn">Ajouter</button>
								</div>
							</div>
						</form>
						<table class="table table-striped">
							<thead>
								<tr>
									<th>ACTION - Type</th>
									<th colspan="2">ACTION - Catégorie</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="action in all_actions_types">
									<td>{{ action.name }}</td>
									<td>{{ action.nameactioncategorie }}</td>
									<td class="end-cell"><button @click="show(action)" class="grey-button">-</button></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-if="tab == 'decideur'">
						<form autocomplete="off" v-on:submit="submitForm">
							<div class="row param-form">
								<div class="form-group col-sm-7">
									<label for="categorie">Nom de la fonction</label>
									<input type="text" id="categorie" class="form-control" v-model="name" required>
								</div>
								<div class="submit-btn col-sm-5">
									<button type="submit" class="green-btn">Ajouter</button>
								</div>
							</div>
						</form>
						<table class="table table-striped">
							<tbody>
								<tr v-for="action in all_decideurs_categories">
									<td>{{ action.name }}</td>
									<td class="end-cell"><button @click="show(action)" class="grey-button">-</button></td>
								</tr>
							</tbody>
						</table>
					</div>
					<!-- <div v-if="tab == 4">
						<form autocomplete="off" v-on:submit="submitForm">
							<div class="row param-form">
								<div class="form-group col-sm-4">
									<label for="categorie">Nom de la fonction</label>
									<input type="text" id="categorie" class="form-control" v-model="name" required>
								</div>
								<div class="form-group col-sm-4">
									<label for="type">Catégorie</label>
									<select v-model="iddecideurcategorie" required>
										<option value="" selected disabled>Choisissez une catégorie</option>
										<option v-bind:value="action.id" v-for="action in all_decideurs_categories">
											{{ action.name }}
										</option>
									</select>
								</div>
								<div class="submit-btn col-sm-4">
									<button type="submit" class="green-btn">Ajouter</button>
								</div>
							</div>
						</form>
						<table class="table table-striped">
							<thead>
								<tr>
									<th>Décideur Public [Fonction]</th>
									<th colspan="2">Décideur Public [Catégorie]</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="action in all_decideurs_fonctions">
									<td>{{ action.name }}</td>
									<td>{{ action.namedecideurcategorie }}</td>
									<td class="end-cell"><button @click="show(action)" class="grey-button">-</button></td>
								</tr>
							</tbody>
						</table>
					</div> -->
					<div v-if="tab == 'domaine'">
						<form autocomplete="off" v-on:submit="submitForm">
							<div class="row param-form">
								<div class="form-group col-sm-8">
									<label for="categorie">Nom du domaine d'intervention</label>
									<input type="text" id="categorie" class="form-control" v-model="name" required>
								</div>
								<div class="submit-btn col-sm-4">
									<button type="submit" class="green-btn">Ajouter</button>
								</div>
							</div>
						</form>
						<table class="table table-striped">
							<tbody>
								<tr v-for="domaine in all_domaine">
									<td>{{ domaine.name }}</td>
									<td class="end-cell"><button @click="show(domaine)" class="grey-button">-</button></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-if="tab == 'type_action_hatvp'">
						<form autocomplete="off" v-on:submit="submitForm">
							<div class="row param-form">
								<div class="form-group col-sm-8">
									<label for="categorie">Type d'action de représentation d'intérêts</label>
									<input type="text" class="form-control" v-model="name" required>
								</div>
								<div class="submit-btn col-sm-4">
									<button type="submit" class="green-btn">Ajouter</button>
								</div>
							</div>
						</form>
						<table class="table table-striped">
							<tbody>
								<tr v-for="type_action_hatvp in all_type_action_hatvp">
									<td>{{ type_action_hatvp.name }}</td>
									<td class="end-cell"><button @click="show(type_action_hatvp)" class="grey-button">-</button></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-if="tab == 'decision'">
						<form autocomplete="off" v-on:submit="submitForm">
							<div class="row param-form">
								<div class="form-group col-sm-8">
									<label for="categorie">Décisions publiques</label>
									<input type="text" class="form-control" v-model="name" required>
								</div>
								<div class="submit-btn col-sm-4">
									<button type="submit" class="green-btn">Ajouter</button>
								</div>
							</div>
						</form>
						<table class="table table-striped">
							<tbody>
								<tr v-for="decision in all_decision">
									<td>{{ decision.name }}</td>
									<td class="end-cell"><button @click="show(decision)" class="grey-button">-</button></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-if="tab == 'recurring'">
						<table class="table table-striped">
							<tbody>
								<template v-for="recurring in all_recurring">
									<tr v-if="current_user_role == 'admin' || recurring.utilisateur.user.id == current_user_id">
										<td>
											Client : {{ recurring.client.user.name }}<br>
											Fréquence : {{ recurring.recurring[0].frequency_rule }}<br>
											Prochaine récurrence : {{ recurring.recurring[0].next_run_day_clean }}<br>
											Action catégorie : {{ recurring.action_categorie.name }}<br>
											Action type : {{ recurring.action_type.name }}<br>
											Action commentaire : {{ recurring.action_commentaire }}<br>
										</td>
										<td class="end-cell">
											<router-link tag="button" :to="{ path: '/reporting/' + recurring.id}" class="grey-button">
												...
											</router-link>
											<button @click="show(recurring)" class="grey-button">-</button>
										</td>
									</tr>
								</template>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
   @import '../sass/app.scss';
</style>

<script>

	import Vue from '../js/app.js'
	import parametres from '../js/params.js';
	import '../js/active.js';

	export default {
	  	data() {
	    	return {
					current_user_role: localStorage.type_user,
					current_user_id: localStorage.id_user,

					all_actions_categories: null,
					all_actions_types: null,
					all_decideurs_categories: null,
					all_decideurs_fonctions: null,

					all_domaine: null,
					all_type_action_hatvp: null,
					all_decision: null,

					all_recurring: null,
					tab: localStorage.type_user == "admin" ? 'catégorie' : 'recurring',
					name: null,
					id: null,
					iddecideurcategorie: null,
					idactioncategorie: null
			}
	    },
	    beforeCreate: function() {
				this.$nextTick(function() {
					this.actioncategorie();
					this.actiontype();
					this.decideurcategorie();
					this.reportingRecurring();

					this.domaine();
					this.type_action_hatvp();
					this.decision();
				})
			},
	    methods: {
	    	actioncategorie(){
	    	  Vue.http.get(
	    	    'api/actioncategorie'
	    	  ).then(response => {
	    	    this.all_actions_categories = response.data.data;
	    	  })
	    	},
	    	actiontype() {
	    	  Vue.http.get(
	    	    'api/actiontype'
	    	  ).then(response => {
	    	    this.all_actions_types = response.data.data;
	    	  })
	    	},
	    	decideurcategorie(){
	    	  Vue.http.get(
	    	    'api/decideurcategorie'
	    	  ).then(response => {
	    	    this.all_decideurs_categories = response.data.data;
	    	  })
	    	},

				domaine() {
					Vue.http.get(
						'api/domaine'
					).then(response => {
						this.all_domaine = response.body
					})
				},
				type_action_hatvp() {
					Vue.http.get(
						'/api/typeActionHatvp'
					).then(response => {
						this.all_type_action_hatvp = response.body
					})
				},
				decision() {
					Vue.http.get(
						'api/decision'
					).then(response => {
						this.all_decision = response.body
					})
				},

				reportingRecurring() {
					Vue.http.post(
					'api/reporting',
						{
							idclient: -1,
							recurring: true,
						}
					).then(response => {
						this.all_recurring = response.data.data;
						console.log('reporting',response.data.data)
					})
				},
				createActionCategorie(event) {
					event.preventDefault()
					parametres.createActionCategorie(this, this.name);
				},
				deleteActionCategorie(event) {
					event.preventDefault()
					parametres.deleteActionCategorie(this, this.id);
				},
				createDecideurCategorie(event) {
					event.preventDefault()
					parametres.createDecideurCategorie(this, this.name);
				},
				deleteDecideurCategorie(event) {
					event.preventDefault()
					parametres.deleteDecideurCategorie(this, this.id)
				},
				createActionType(event) {
					event.preventDefault()
					parametres.createActionType(this, this.name, this.idactioncategorie);
				},
				deleteActionType(event) {
					event.preventDefault()
					parametres.deleteActionType(this, this.id);
				},

				create_domaine(event) {
					event.preventDefault();
					parametres.create_domaine(this, this.name)
				},
				create_type_action_hatvp(event) {
					event.preventDefault();
					parametres.create_type_action_hatvp(this, this.name)
				},
				create_decision(event) {
					event.preventDefault();
					parametres.create_decision(this, this.name)
				},

				delete_domaine(event) {
					event.preventDefault();
					parametres.delete_domaine(this, this.id)
				},
				delete_type_action_hatvp(event) {
					event.preventDefault();
					parametres.delete_type_action_hatvp(this, this.id)
				},
				delete_decision(event) {
					event.preventDefault();
					parametres.delete_decision(this, this.id)
				},

				submitForm() {
					if(this.tab == 'catégorie') {
						this.createActionCategorie(event)
					}
					else if(this.tab == 'action') {
						this.createActionType(event)
					}
					else if (this.tab == 'decideur') {
						this.createDecideurCategorie(event)
					}
					else if (this.tab == 'domaine') {
						this.create_domaine(event)
					}
					else if (this.tab == 'type_action_hatvp') {
						this.create_type_action_hatvp(event)
					}
					else if (this.tab == 'decision') {
						this.create_decision(event)
					}

				},
				destroy() {
					this.$modal.hide('modal-confirm')

					if(this.tab == 'catégorie') {
						this.deleteActionCategorie(event)
					}
					else if(this.tab == 'action') {
						this.deleteActionType(event)
					}
					else if (this.tab == 'decideur') {
						this.deleteDecideurCategorie(event)
					}
					else if (this.tab == 'domaine') {
						this.delete_domaine(event)
					}
					else if (this.tab == 'type_action_hatvp') {
						this.delete_type_action_hatvp(event)
					}
					else if (this.tab == 'decision') {
						this.delete_decision(event)
					}
				},
				showSuccessCreate() {
					this.$modal.show('dialog', {
						text: 'Votre entrée a bien été créée',
						class: 'modal-success',
						buttons: [
							{ title: 'Fermer' }
						]
					})
				},
				showSuccessDelete() {
					this.$modal.show('dialog', {
						text: 'Votre entrée a bien été supprimée',
						class: 'modal-success',
						buttons: [
							{ title: 'Fermer' }
						]
					})
				},
				showError() {
					this.$modal.show('dialog', {
						text: 'Il y a eu une erreur, imposible de compléter votre action',
						class: 'modal-error',
						buttons: [
							{ title: 'Fermer' }
						]
					})
				},
				show(action) {
					this.id = action.id;
					this.$modal.show('modal-confirm');
				},
	    }
	}

</script>



// WEBPACK FOOTER //
// Parametre.vue?16885d4e